import api from 'api';
import {usePostApi} from 'common/hooks/usePostApi';
import {currentLocationIsLogin} from 'common/utils';
import {loginTypes} from 'features/login/redux';
import {useDispatch} from 'react-redux';
import {action} from 'redux/helpers';
import {_mfaSetupResp} from 'types/diplomat/authentication/MfaSetupResponse';
import {IMfaVerifyRequest} from 'types/diplomat/authentication/MfaVerifyRequest';
import history from 'redux/history';
import {FormOnSubmitHelpers} from 'components/hook-form/Formik';
import {get} from 'lodash';

export const useVerifyCode = (onClose: () => void) => {
   const dispatch = useDispatch();
   const {request: verify} = usePostApi(api.mfaVerify, {
      onSuccess(data) {
         onClose();
         dispatch(action(loginTypes.LOGIN.SUCCESS, data));
         if (currentLocationIsLogin()) {
            history.push('/');
         }
      },
   });
   const onSubmit = (
      values: IMfaVerifyRequest,
      {setSubmitting, setErrors}: FormOnSubmitHelpers<IMfaVerifyRequest>
   ) => {
      verify(JSON.stringify(values), {
         onFailure(e, message) {
            console.debug('on error', e, message);
            setSubmitting(false);
            setErrors({
               otp: get(e.body || e, 'errors.0.message', message || e),
            });
         },
      });
   };

   return onSubmit;
};
